import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { KudosRecipientsInputListComponent } from "../create-kudos/kudos-recipients-input-list/kudos-recipients-input-list.component";
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Kudos, KudosRecipients, KudosType } from "@teammood/timeline";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { NgClass } from "@angular/common";
import { TmMoodPickersComponent } from "../../../../shared/ui/moodpickers/mood-pickers.component";
import { debounceTime, distinctUntilChanged, Subject, takeUntil, tap } from "rxjs";

@Component({
    selector: "tm-edit-kudos-box",
    templateUrl: "./edit-kudos-box.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        KudosRecipientsInputListComponent,
        FormsModule,
        TranslateModule,
        NgClass,
        ReactiveFormsModule,
        TmMoodPickersComponent
    ]
})
export class EditKudosBoxComponent implements OnInit, OnDestroy {

    @Input({required: true})
    kudos: Kudos;

    @Input({required: true})
    teamId: string;

    protected kudosCommentCtrl = new FormControl<string>('');

    protected error: string;

    @Output()
    onEdit: EventEmitter<Kudos> = new EventEmitter();

    @Output()
    onCancel: EventEmitter<void> = new EventEmitter();

    private _destroy$ = new Subject<void>();

    constructor(private translate: TranslateService) {
    }

    ngOnInit() {
        this.kudosCommentCtrl.setValue(this.kudos.message.body);

        this.kudosCommentCtrl.valueChanges.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            tap(() => {
                this.kudos.message.body = this.kudosCommentCtrl.getRawValue();
            }),
            takeUntil(this._destroy$)
        ).subscribe();
    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }

    protected onTeammatesListChange(recipients: KudosRecipients) {
        this.kudos.recipients = recipients;
    }

    protected updateKudosType(kudosType: KudosType){
        this.kudos.kudosType = kudosType;
    }

    protected fromMoodPicker (element: string) {
        if (this.kudos.message.body) {
            this.kudosCommentCtrl.setValue(this.kudos.message.body + ' ' + element);
        } else {
            this.kudosCommentCtrl.setValue(element);
        }
    }

    protected saveUpdate() {
        if (this.kudos.recipients.selectedTeammates.length > 0 || this.kudos.recipients.allTeamSelected) {
            if (this.kudos.kudosType && this.kudos.message.body.length > 0){
                this.onEdit.emit(this.kudos);
            } else{
                this.error = this.translate.instant('kudos.card.edition.error')
            }
        }
    }

    protected cancelUpdate() {
        this.onCancel.emit();
    }

}

// import * as angular from 'angular';
// import { UserActivityService } from "../../../../../../lib/user-activity/user-activity.service";
// import { KudosRecipients } from "@teammood/timeline";
// editKudosBox.$inject = ['$translate', 'UserActivityService']
//
// export function editKudosBox($translate, userActivityService: UserActivityService) {
//
//     return {
//         restrict: 'E',
//         template: require('!ng-cache-loader?prefix=[dir]/[dir]!./edit_kudos_box.directive.html'),
//         scope: {
//             kudos: '=',
//             teamId: '=',
//             timelineItemEditMode: '=',
//             onEdit: '&',
//             onCancel: '&'
//         },
//         link: function (scope, element) {
//             const inputSelector = '#kudos-textarea-to-edit'
//             const kudosInput = angular.element(element[0].querySelector(inputSelector));
//
//             if(!scope.kudos.message){
//                 scope.kudos.message = '';
//             }
//
//             function loadTeamMateList (teamId){
//                 userActivityService.getTeamMatesList(teamId).then(orderedList => {
//                     const allTeammatesOrdered = orderedList;
//                     scope.teammatesList = {
//                         teammates: allTeammatesOrdered,
//                         allTeammates: allTeammatesOrdered,
//                         displayTeammatesList: false
//                     }
//                 })
//             }
//
//             scope.saveUpdate = function (timelineItem){
//                 if (timelineItem.recipients.selectedTeammates.length > 0 || timelineItem.recipients.allTeamSelected) {
//                     if(timelineItem.kudosType && timelineItem.message.untransformedBody.length > 0){
//                         if(scope.kudos.recipients.selectedTeammates.length === 1 &&  scope.kudos.recipients.selectedTeammates[0].fullname === 'All Teammates'){
//                             scope.kudos.recipients.selectedTeammates = [...scope.teammatesList.allTeammates];
//                             scope.kudos.recipients.allTeamSelected = true;
//                         }
//                         scope.onEdit(timelineItem);
//                     }else{
//                         scope.error = $translate.instant('kudos.card.edition.error')
//                     }
//                 }
//             }
//
//         }
//     };
// }